import * as React from "react";


const Page404 = () => {
    return (
        <div style={{margin: 30}}>
            <h1 className="error-header">Application is not available</h1>
            <p>Sorry, we are unable to process your request at this endpoint. It may not exist or it's access is
                restricted.</p>

            <div className="alert alert-info">
                <p className="info">
                    <span className="icon icon-sm dls-icon-info dls-gray-05"/>&nbsp;Possible reasons you are seeing this
                    page:
                </p>
                <ul style={{paddingLeft: 30}}>
                    <li>
                        <strong>The page doesn't exist.</strong> Make sure the url was typed correctly and that a page
                        matching this url exists.
                    </li>
                    <li>
                        <strong>You don't have access to view this page.</strong> Cheek with CTP Product team
                        if you have access to view this page.
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Page404;
